<template>
<div>
    <div class="card p-3">
            <div class="table-responsive">
              <div
                class="
                  dataTables_wrapper                  
                  no-footer
                "
              >
                <div class="dataTables_length">
                  <span style="margin-right: 10px"
                    ><label for="">Show </label>
                  </span>
                  <select
                    v-model="pageSize"
                    class="form-control form-control-sm"
                    aria-label="Default select example"
                    @change="pageChange(1)"
                  >
                    <option selected>50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    <option value="2000">2000</option>
                  </select>

                  <span style="margin-left: 10px">
                    <label for=""> Entries </label></span
                  >
                </div>
              </div>
              <table
                data-height="300"
                id="table001"
                class="
                  table
                  display
                  dataTable
                  table-bordered
                  text-center
                  table-striped
                  no-wrap
                "
              >
                <thead class="thead-dark">
                  <tr>
                    <th style="text-align: start">
                      Action 
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(0)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Status
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(1)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Patient Name
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(2)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Veins ID
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(3)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                     <th style="text-align: start">
                      Confirmation Number/Payment ID
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(2)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      External ID
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(4)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Date of Service
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(5)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Date Requested
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(6)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Sent to
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(7)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Amount Requested
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(8)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Refund Amount
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(9)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Note
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(10)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                <tr v-if="filteredPaymentRequests.length == 0">
                      <td align="center" colspan="100">
                        <strong> No data available</strong>
                      </td>
                 </tr>
                  <tr
                    v-for="(pay, ndx01) in filteredPaymentRequests"
                    :key="ndx01"
                  >
                    <td>
                      
                     
                      <div class="btn-group">
                        <button
                          v-if="pay.status == 1"
                          type="button"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="paymentCollectMethodModal(pay)"
                        >
                          <strong>Collect Payment </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 2"
                          type="button"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="paymentCollectMethodModal(pay)"
                        >
                          <strong>Collect Payment </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 5"
                          type="button"
                          class="btn btn-success"
                          style="border-top-right-radius:4px;border-bottom-right-radius:4px"
                            :style="colorStyle(pay.status)"
                          @click="sendReceipt(pay)"
                        >
                          <strong>Receipt </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 3"
                          type="button"
                          class="btn btn-success"
                            :style="colorStyle(pay.status)"
                          @click="paymentCollectMethodModal(pay)"
                        >
                        <strong>Reminder </strong>
                        </button>
                         <button
                          v-else-if="pay.status == 4"
                          type="button"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="showSubmitRefundModal(pay)"
                        >
                          <strong>Refund </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 6"
                          type="button"
                          class="btn btn-success"
                            :style="colorStyle(pay.status)"
                          @click="showSubmitRefundModal(pay)"
                        >
                          <strong>Refund </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 7"
                          type="button"
                          class="btn btn-success"
                            :style="colorStyle(pay.status)"
                          @click="paymentCollectMethodModal(pay)"
                        >
                          <strong>Collect Payment </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 9"
                          type="button"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="showSubmitRefundModal(pay)"
                        >
                        <strong> Refund</strong>
                        </button>
                        <span
                          v-if="pay.status == 5"
                        >                          
                        </span>       
                        <button
                          v-else-if="updButton == 1"
                          type="button"
                          class="
                            btn btn-success
                            dropdown-toggle dropdown-toggle-split
                          "
                          :style="colorStyle(pay.status)"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                        <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <button
                          v-else
                          type="button"
                          class="
                            btn btn-success
                            dropdown-toggle dropdown-toggle-split
                          "
                          :style="colorStyle(pay.status)"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          :disabled="updButton == 0"
                        >
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div v-if="pay.status==4" class="dropdown-menu animated flipInY">
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="sendReceipt(pay)"
                            >Receipt</a
                          >
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="showReconcileModel(pay)"
                            >Reconciled</a
                          >
                        </div>
                        <div v-else-if="pay.status==6" class="dropdown-menu animated flipInY">
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="sendReceipt(pay)"
                            >Receipt</a
                          >
                          <!-- this was not there  -->
                          <!-- <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="showReconcileModel(pay)"
                            >Reconciled</a
                          > -->
                        </div>
                        <div v-if="pay.status==9" class="dropdown-menu animated flipInY">
                        <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="sendReceipt(pay)"
                            >Receipt</a
                          >
                          <a
                            v-if=" pay.status==1"
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="deletePayment(pay)"
                            >Delete</a
                          >
                        </div>
                        <div v-else class="dropdown-menu animated flipInY">
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="showReminderModel(pay)"
                            >Reminder</a
                          >
                          <a
                            v-if="pay.status==1"
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="deletePayment(pay)"
                            >Delete</a
                          >
                        </div>
                        </div>
                    </td>
                    <td>
                      <div class="form-group" >
                        <span
                          v-if="pay.status == 1"
                          class="bs-label label-danger badgeBorder"
                         :style="colorStyle(pay.status)"
                        >
                          Requested
                        </span>
                        <span
                          v-else-if="pay.status == 2"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Pending
                        </span>
                        <span
                          v-else-if="pay.status == 3"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Disputed
                        </span>
                        <span
                          v-else-if="pay.status == 4"
                          class="bs-label label-danger badgeBorder"
                         :style="colorStyle(pay.status)"
                        >
                          Paid
                        </span>
                        <span
                          v-else-if="pay.status == 5"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Refunded
                        </span>
                        <button
                          v-else-if="pay.status == 6"
                         class="btn btn-success"
                          :style="colorStyle(pay.status)"
                        >
                          Partially Refunded
                        </button>
                        
                        <p
                          v-else-if="pay.status == 7"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Partially Paid
                        </p>
                          <p
                          v-else-if="pay.status == 9"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Reconciled
                        </p>
                      </div>
                    </td>
                    <td>{{ pay.firstName + " " + pay.lastName }}</td>
                    <td>
                      <div>
                          <span :class="
                          pay.ptid == null || pay.ptid == ''
                              ? ''
                              : 'bs-label label-danger badgeBorder'
                          " 
                          :style="colorStyle(pay.status)"
                          >
                          {{ pay.ptid }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div>
                          <span :class="
                          pay.ptid == null || pay.ptid == ''
                              ? ''
                              : 'bs-label label-danger badgeBorder'
                          " 
                          :style="colorStyle(pay.status)"
                          >
                          BID{{ pay.billNo }}
                        </span><br/><br/>
                         <span :class="
                          pay.ptid == null || pay.ptid == ''
                              ? ''
                              : 'bs-label label-danger badgeBorder'
                          " 
                          :style="colorStyle(pay.status)"
                          >
                          PYI{{ pay.pndx }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <span :class="
                            pay.externalId == null || pay.externalId == ''
                              ? ''
                              : 'bs-label label-danger badgeBorder'
                          "
                        :style="colorStyle(pay.status)"
                        >
                          {{ pay.externalId }}
                        </span>
                      </div>
                    </td>
                    <td>{{ pay.dos }}</td>
                    <td>{{ pay.billDate }}</td>
                    <td>
                      <div>
                        <span class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)">
                          {{ pay.email }}
                        </span>
                      </div>
                      <br />
                      <div>
                        <span class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)">
                          {{ pay.phone }}
                        </span>
                      </div>
                    </td>
                    <td>
                      {{"$"+ pay.amount }} <br />
                      {{ pay.paymentmethodStr }}
                      <span v-if="pay.paymentMethod == 1"> Processed </span>
                      <span v-else-if="pay.paymentMethod == 0"> </span>
                      <span v-else> Collected </span>
                      {{ pay.paymentDateStr }}
                    </td>
                    <td>{{"$"+ pay.refundAmount }}</td>
                    <td>
                      {{ pay.comment }} <br />
                      <a
                        v-if="pay.uploadedFileUrl !== ''"
                        :href="pay.uploadedFileUrl"
                      >
                        View Attachment
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <nav aria-label="Page navigation">
            <span
              style="padding-left: 40px"
              v-if="totalRows < pageSize * pageNumber"
              >showing {{ totalRows }} of {{ totalRows }} records</span
            >
            <span style="padding-left: 40px" v-else
              >showing {{ pageSize * pageNumber }} of
              {{ totalRows }} records</span
            >
            <ul class="pagination" style="float: right">
              <li class="page-item colorActive">
                <span v-if="pageNumber == 1">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Previous')"
                  >
                    Previous
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Previous')">
                    Previous
                  </button>
                </span>
              </li>
               <!--show pagination--> 
                <li v-if="showPagesMin > 1">
                 <button class="page-link" @click="pageChange(1)">
                    1
                  </button>
                </li>
                 <li v-if=" showPagesMin>1 ">
                 <button
                    disabled
                    class="page-link disabledColor"
                  >
                    ...
                    </button>
                 </li>
            <!--show pagination--> 
              <li
                v-for="pageNum in totalPages"
                :key="pageNum"
                class="page-item colorActive"
              >
               <span v-if="pageNum >= showPagesMin && pageNum <= showPagesMax"> 
                <span v-if="pageNumber == pageNum"
                  ><button
                    class="page-link activeColor"
                    disabled
                    @click="pageChange(pageNum)"
                  >
                    {{ pageNum }}
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange(pageNum)">
                    {{ pageNum }}
                  </button></span
                >
                </span>
              </li>
            <!--show pagination-->          
              <li v-if="totalPagesSuggest > 10 && (totalPagesSuggest-4) >= pageNumber">
                 <button
                    disabled
                    class="page-link disabledColor"
                  >
                    ...
                  </button>
              </li>
             <li v-if="totalPages > 10 &&  (totalPages-4) >= pageNumber">
                 <button class="page-link" @click="pageChange(totalPages)">
                    {{ totalPages }}
                  </button>
             </li>
               <!--show pagination-->  
              <li class="page-item colorActive">
                <span v-if="pageNumber == totalPages">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Next')"
                  >
                    Next
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Next')">
                    Next
                  </button>
                </span>
              </li>
            </ul>
          </nav>
    </div>
   <Dialog
   :focusTrap="false"
      v-model:visible="refundAmountModal"
      style="width: 30%; max-height: 100%"
      @hide="closeModalRem()"
      position="center"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel"><strong > Enter Refund Amount</strong></h4>
      </template>
      <div>
       <div class="form-group focused" style="" >
         <input  type="text" class="form-control" id="refund" tabindex="1"
         v-model="refundAmount"
         :placeholder="'Amount Refunded (In $$), can not be greater then $' + (ActivePaymentRequest.amount - ActivePaymentRequest.refundAmount)"
          aria-labelledby="cname" :max="ActivePaymentRequest.amount" 
          @keypress="amountRefundCheck($event,refundAmount)"
         >
      </div>
      </div>
      <template #footer>
       <div class="swal2-actions" style="display: flex;margin-top:-10px;">
         <button type="button"
          class="swal2-confirm swal2-styled"
           aria-label="" 
           style="display: inline-block; background-color: rgb(0, 194, 146);
            border-left-color: rgb(0, 194, 146);
             border-right-color: rgb(0, 194, 146);
             margin: 15px;"
             @click="refundPayment()"
             >
           Refund</button>
           <button type="button" class="swal2-cancel swal2-styled"
            aria-label=""
            @click="closeRefundAmountModal()"
            style="display: inline-block;margin: 15px; ">Cancel</button></div>
      </template>

    </Dialog>

 <Dialog
 :focusTrap="false"
      v-model:visible="displayReceipt"
      style="width: 30%; max-height: 40%"
      @hide="closeModalRem()"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Send Receipt to following details </h4>
      </template>

      <div class="row">
        <div class="col-12" style="margin-top: 22px">
          <div class="form-group">
            <span class="p-float-label">
              <InputText
                v-model="SendReceiptRequest.Email"
                style="width: 400px"
                type="text"
                id=""
                placeholder=""
              />
              <label id="font1">Email</label>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <span class="p-float-label">
              <InputMask
                v-model="SendReceiptRequest.Phone"
                mask="***-***-****"
                style="width: 400px"
              />
              <label id="font1">Phone Number</label>
            </span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          @click="sendReceiptClick()"
          class="btn btn-success waves-effect waves-light"
        >
          Send
        </button>
        <button
          type="button"
          @click="closeRecepit()"
          class="btn btn-danger waves-effect waves-light"
        >
          Close
        </button>
      </div>
    </Dialog>

    <Dialog
    :focusTrap="false"
      v-model:visible="displayRem"
      style="width: 30%; max-height: 40%"
      @hide="closeModalRem()"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Reminder</h4>
      </template>

      <div class="row">
        <div class="col-12" style="margin-top: 22px">
          <div class="form-group">
            <span class="p-float-label">
              <InputText
                v-model="Reminder.email"
                style="width: 400px"
                type="text"
                id=""
                placeholder=""
              />
              <label id="font1">Email</label>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <span class="p-float-label">
              <InputMask
                v-model="Reminder.phone"
                mask="***-***-****"
                style="width: 400px"
              />
              <label id="font1">Phone Number</label>
            </span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          @click="sendReminderClick()"
          class="btn btn-success waves-effect waves-light"
        >
          Send
        </button>
        <button
          type="button"
          @click="closeModalRem()"
          class="btn btn-danger waves-effect waves-light"
        >
          Close
        </button>
      </div>
    </Dialog>

    <!-- paymentMethod v2-->
    <!-- <div
      id="paymentMethod"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Select A Payment Method</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row text-center">
                <div class="col m-2 p-2">
                  <a href="" data-target="#debit" data-toggle="modal">
                    <i class="far fa-credit-card fa-5x mb-3 blue-text"></i>
                    <h4 class="font-weight-bold">Credit Or Debit Card</h4>
                  </a>
                </div>

                <div class="col m-2 p-2">
                  <a href="" data-target="#cash" data-toggle="modal">
                    <i class="fas fa-hand-holding-usd fa-5x mb-3 blue-text"></i>
                    <h4 class="font-weight-bold">Cash</h4>
                  </a>
                </div>

                <div class="col m-2 p-2">
                  <a href="" data-target="#cheque" data-toggle="modal">
                    <i class="fas fa-money-check-alt fa-5x mb-3 blue-text"></i>
                    <h4 class="font-weight-bold">Cheque</h4>
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div> -->
    <!-- paymentMethod v2-->

    <!-- Payment Authorize Credit -->
    <div
      id="debit"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Payment Via Authorize</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <h4 class="font-weight-bold h4-responsive">
              Payment Verfication will be Done
            </h4>
            <form class="floating-labels m-t-40">
              <div
                class="form-group m-b-40"
                :class="[
                  aSinglePaymentReceived.holderName != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                              <InputText
                  type="text"
                  class="form-control float-class"
                  id=""
                   maxlength="30"
                  v-model="aSinglePaymentReceived.holderName"
                /><span class="bar"></span>
                <label for="" id="font1">Card Holder Name<span style="color:red"> *</span></label>
                </span>
              </div>
              <div
                class="form-group m-b-40"
                :class="[
                  aSinglePaymentReceived.cardNumber != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                <InputText
                  v-mask="'####-####-####-####'"
                  type="tel"
                  class="form-control float-class"
                  id=""
                  v-model="aSinglePaymentReceived.cardNumber"
                /><span class="bar"></span>
                <label for="" id="font1">Card Number <span style="color:red"> *</span></label>
                </span>
              </div>
              <div
                class="form-group m-b-40"
                :class="[
                  aSinglePaymentReceived.cardCVC != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                              <InputText
                  v-mask="'######'"
                  type="tel"
                  class="form-control float-class"
                  id=""
                  v-model="aSinglePaymentReceived.cardCVC"
                /><span class="bar"></span>
                <label for="" id="font1">Card CVC <span style="color:red"> *</span></label>
                </span>
              </div>
              <div
                class="form-group m-b-40"
                :class="[aSinglePaymentReceived.zip != null ? '' : 'focused']"
              >
                <span class="p-float-label">
                              <InputText
                  type="text"
                  class="form-control float-class"
                  id=""
                  maxlength="8"
                  v-model="aSinglePaymentReceived.zip"
                /><span class="bar"></span>
                <label for="" id="font1">Zip <span style="color:red"> *</span></label>
                </span>
              </div>
              <div
                class="form-group m-b-40"
                :class="[
                  aSinglePaymentReceived.amount != null ? '' : 'focused',
                ]"
              >
                <span class="p-float-label">
                              <InputText
                  type="number"
                  class="form-control float-class"
                  id=""
                  @keypress="isNumber($event)"
                  v-model="aSinglePaymentReceived.amount"
                /><span class="bar"></span>
                <label for="" id="font1">Amount <span style="color:red"> *</span></label>
                </span>
              </div>
              <div
                class="form-group"
                :class="[
                  aSinglePaymentReceived.comment != null ? 'focused' : '',
                ]"
              >
                <label for="" class="control-label">Comment:</label>
                <textarea
                  class="form-control"
                  id=""
                  maxlength="255"
                  v-model="aSinglePaymentReceived.comment"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              id="creditCardPayment"
              @click="paymentReceivedClick('credit-card')"
            >
              Process
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Payment Authorize Credit  -->

    <!-- Payment Authorize Cash -->
    <div
      id="cash"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Cash On The Spot</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="form-group m-b-40"
                v-bind:class="[
                  aSinglePaymentReceived.amount != null ? 'focused' : '',
                ]">
                <input
                  type="number"
                  class="form-control"
                  id=""
                  @keypress="isNumber($event)"
                  v-model="aSinglePaymentReceived.amount"
                /><span class="bar"></span>
                <label for="">Amount(In $)</label>
              </div>
              <div class="form-group"
               v-bind:class="[
                  aSinglePaymentReceived.comment.length > 0 ? 'focused' : '',
                ]">
                <label for="" class="control-label">Comment:</label>
                <textarea
                  class="form-control"
                  id=""
                   maxlength="255"
                  v-model="aSinglePaymentReceived.comment"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              id="cashPayment"
              @click="paymentReceivedClick('cash')"
            >
              Collect
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Payment Authorize Cash  -->

    <!-- Payment Authorize cheque -->
    <div
      id="cheque"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Payment Via Cheque</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div class="form-group m-b-40"
               v-bind:class="[
                  aSinglePaymentReceived.tdNumber.length > 0 ? 'focused' : '',
                ]">
                <input
                 
                  type="text"
                  class="form-control"
                  id=""
                  v-model="aSinglePaymentReceived.tdNumber"
                /><span class="bar"></span>
                <label for="">Cheque Number</label>
              </div>
              <div class="form-group m-b-40"
              v-bind:class="[
                  aSinglePaymentReceived.amount != null ? 'focused' : '',
                ]">
                <input
                 type="number"
                  class="form-control"
                  id=""
                  @keypress="isNumber($event)"
                  v-model="aSinglePaymentReceived.amount"
                /><span class="bar"></span>
                <label for="">Amount(In $)</label>
              </div>
              <div class="form-group m-b-40"
              v-bind:class="[
                  aSinglePaymentReceived.holderName.length > 0 ? 'focused' : '',
                ]">
                <input
                  type="text"
                  class="form-control"
                  id=""
                  maxlength="100"
                  v-model="aSinglePaymentReceived.holderName"
                /><span class="bar"></span>
                <label for="">Cheque Holder Name</label>
              </div>
              <div class="form-group"
               v-bind:class="[
                  aSinglePaymentReceived.comment.length > 0 ? 'focused' : '',
                ]">
                <label for="" class="control-label">Comment:</label>
                <textarea
                  class="form-control"
                  id=""
                  maxlength="255"
                  v-model="aSinglePaymentReceived.comment"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              id="chequePayment"
              @click="paymentReceivedClick('cheque')"
            >
              Collect
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Payment Authorize cheque  -->

    <!-- $$**$$ Begin -->
    <div
      class="modal fade"
      id="newptModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="display: none"
      data-keyboard="false" data-backdrop="static"
    >
      <div class="modal-dialog cascading-modal modal-lg">
        <div class="modal-content" style="width: 158% !important; left: -200px">
          <PatientComponent v-bind:propTarget="propPatientSource" @destroyProp = "changeVAL">
          </PatientComponent>
        </div>
      </div>
    </div>

     <Dialog
     :focusTrap="false"
      v-model:visible="displayPayMethod"
      style="width: 30%; max-height: 100%"
      @hide="closeModalRem()"
      position="top"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Select A Payment Method</h4>
      </template>
      <form>
        <div class="row text-center">
          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitPaymentModal(1)">
              <i class="far fa-credit-card fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Credit Or Debit Card</h4>
            </a>
          </div>

          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitPaymentModal(2)">
              <i class="fas fa-hand-holding-usd fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Cash</h4>
            </a>
          </div>

          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitPaymentModal(3)">
              <i class="fas fa-money-check-alt fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Cheque</h4>
            </a>
          </div>
        </div>
      </form>
    </Dialog>

     <!-- card payment method -->
    <Dialog
    :focusTrap="false"
      v-model:visible="cardModal"
      style="width: 30%; max-height: 100%"
      @hide="closeModalRem()"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Select A Payment Method</h4>
      </template>
      <hr />
      <h4 class="font-weight-bold h4-responsive">
        Payment Verfication will be Done
      </h4>
      <form class="floating-labels m-t-40">
        <div
          class="form-group m-b-40"
          :class="[aSinglePaymentReceived.holderName != null ? 'focused' : '']"
        >
          <input
            type="text"
            class="form-control"
            id="chName"
            tabindex="1"
            aria-labelledby="cname"
            maxlength="100"
            v-model="aSinglePaymentReceived.holderName"
          /><span class="bar"></span>
          <label for="chName" id="cname"
            >Card Holder Name<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group m-b-40"
          :class="[aSinglePaymentReceived.cardNumber != null ? 'focused' : '']"
        >
          <input
            v-mask="'####-####-####-####'"
            type="tel"
            class="form-control"
            id="cNumber"
            tabindex="2"
            aria-labelledby="cardNum"
            v-model="aSinglePaymentReceived.cardNumber"
          /><span class="bar"></span>
          <label for="cNumber" id="cardNum"
            >Card Number<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group m-b-40"
          :class="[
            aSinglePaymentReceived.ExpirationDate != null ? 'focused' : 'focused',
          ]"
        >
          <input
            v-model="aSinglePaymentReceived.ExpirationDate"
            type="month"
            class="form-control required"
            id="filler_name"
            name="filler_name"
            tabindex="3"
          /><span class="bar"></span>
          <label for="exdate" id="exdate"
            >Expiration Date<span style="color: red"> *</span></label
          >
        </div>

        <div
          class="form-group m-b-40"
          :class="[aSinglePaymentReceived.cardCVC != null ? 'focused' : '']"
        >
          <input
            v-mask="'######'"
            type="tel"
            class="form-control"
            id="cvc"
            aria-labelledby="cardCVC"
            v-model="aSinglePaymentReceived.cardCVC"
            tabindex="4"
          /><span class="bar"></span>
          <label for="cvc" id="cardCVC"
            >Card CVC<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group m-b-40"
          :class="[aSinglePaymentReceived.zip != null ? 'focused' : '']"
        >
          <input
            type="text"
            class="form-control"
            id="cardzip"
            aria-labelledby="czip"
            maxlength="8"
            tabindex="5"
            v-model="aSinglePaymentReceived.zip"
          /><span class="bar"></span>
          <label for="cardzip" id="czip"
            >Zip<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group m-b-40"
          :class="[aSinglePaymentReceived.amount != null ? 'focused' : '']"
        >
          <input
           disabled
            type="number"
            class="form-control"
            id="cAmount"
            aria-labelledby="amnt"
            @keypress="isNumber($event)"
            :max="limitAmount"
            tabindex="6"
            v-model="aSinglePaymentReceived.amount"
          /><span class="bar"></span>
          <label for="cAmount" id="amnt"
            >Amount<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group"
          v-bind:class="[
            aSinglePaymentReceived.comment != null ? 'focused' : '',
          ]"
        >
          <textarea
            class="form-control"
            id="cardCmnt"
            aria-labelledby="commnt"
            maxlength="255"
            tabindex="7"
            v-model="aSinglePaymentReceived.comment"
          ></textarea
          ><span class="bar"></span>
          <label for="cardCmnt" id="commnt" class="control-label"
            >Comment<span style="color: red"> *</span>:</label
          >
        </div>
      </form>
      <template #footer>
        <button
          :disabled="btnProColl == true"
          type="button"
          class="btn btn-outline-success waves-effect waves-light col-12"
          id="chequePayment"
          style="width: 100%"
          @click="paymentReceivedClick('credit-card')"
        >
          Process
        </button>
      </template>
    </Dialog>
    
    <!-- cash payment method -->
    <Dialog
    :focusTrap="false"
      v-model:visible="cashModal"
      style="width: 30%; max-height: 40%"
      @hide="closeModalRem()"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Select A Payment Method</h4>
      </template>
      <hr />
      <form class="floating-labels m-t-40">
        <div
          class="form-group m-b-40"
          v-bind:class="[
            aSinglePaymentReceived.amount != null ? 'focused' : '',
          ]"
        >
          <input
          disabled
            type="number"
            class="form-control"
            id="cashAmount"
            aria-labelledby="camount"
            @keypress="isNumber($event)"
            v-model="aSinglePaymentReceived.amount"
            :max="limitAmount"
          /><span class="bar"></span>
          <label for="cashAmount" id="camount"
            >Amount(In $)<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group"
          v-bind:class="[
            aSinglePaymentReceived.comment.length > 0 ? 'focused' : '',
          ]"
        >
          <label for="cashCmnt" id="cComment" class="control-label"
            >Comment<span style="color: red"> *</span>:</label
          >
          <textarea
            maxlength="255"
            class="form-control"
            id="cashCmnt"
            aria-labelledby="cComment"
            v-model="aSinglePaymentReceived.comment"
          ></textarea
          ><span class="bar"></span>
        </div>
      </form>
      <template #footer>
        <button
          :disabled="btnProColl == true"
          type="button"
          class="btn btn-outline-success waves-effect waves-light col-12"
          id="chequePayment"
          style="width: 100%"
          @click="paymentReceivedClick('cash')"
        >
          Collect
        </button>
      </template>
    </Dialog>

    <!-- cheque payment method -->
    <Dialog
    :focusTrap="false"
      v-model:visible="chequeModal"
      style="width: 30%; max-height: 100%"
      @hide="closeModalRem()"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Select A Payment Method </h4>
      </template>
      <hr />
      <form class="floating-labels m-t-40">
        <div
          class="form-group m-b-40"
          v-bind:class="[
            aSinglePaymentReceived.tdNumber.length > 0 ? 'focused' : '',
          ]"
        >
          <input
           
            type="text"
            class="form-control"
            id="chkNumber"
            aria-labelledby="chk"
            v-model="aSinglePaymentReceived.tdNumber"
          /><span class="bar"></span>
          <label for="chkNumber" id="chk"
            >Cheque Number<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group m-b-40"
          v-bind:class="[
            aSinglePaymentReceived.amount != null ? 'focused' : '',
          ]"
        >
          <input
            disabled
            type="number"
            class="form-control"
            id="chkAmount"
            aria-labelledby="chkamnt"
            @keypress="isNumber($event)"
            v-model="aSinglePaymentReceived.amount"
            :max="limitAmount"
          /><span class="bar"></span>
          <label for="chkAmount" id="chkamnt"
            >Amount(In $)<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group m-b-40"
          v-bind:class="[
            aSinglePaymentReceived.holderName.length > 0 ? 'focused' : '',
          ]"
        >
          <input
            type="text"
            class="form-control"
            id="cholderNAme"
            aria-labelledby="cnam"
            maxlength="100"
            v-model="aSinglePaymentReceived.holderName"
          /><span class="bar"></span>
          <label for="cholderName" id="cnam"
            >Cheque Holder Name<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group"
          v-bind:class="[
            aSinglePaymentReceived.comment.length > 0 ? 'focused' : '',
          ]"
        >
          <label for="chComment" id="chdnam" class="control-label"
            >Comment<span style="color: red"> *</span>:</label
          >
          <textarea
            class="form-control"
            id="chComment"
            aria-labelledby="chdnam"
            maxlength="255"
            v-model="aSinglePaymentReceived.comment"
          ></textarea
          ><span class="bar"></span>
        </div>
      </form>
      <template #footer>
        <button
          :disabled="btnProColl == true"
          type="button"
          class="btn btn-outline-success waves-effect waves-light col-12"
          id="chequePayment"
          style="width: 100%"
          @click="paymentReceivedClick('cheque')"
        >
          Collect
        </button>
      </template>
    </Dialog>
    <!-- payment method modal -->
</div>
</template>


<script>
import axios from "axios";
import Swal from "sweetalert2";
import PatientComponent from "../views/Patients/PatientComponent.vue"; // $$**$$
import PatientsSearchComponent from "../views/VeinsTracker/PatientsSearchComponent.vue";

export default {
  name: "PaymentRequest_1",

  // $$**$$
  components: {
    // PatientComponent,
    // PatientsSearchComponent
  },
 props: ["removeids", "visitId", "FetchTableData","AppModelId" ],
  data() {
    return {
       //Page
      showPagesMin:1,
      showPagesMax:5,

        displayReceipt: false,
        SendReceiptRequest:{
        PatientId:0,
        VisitId:0,
        LocalDateTime:new Date,
        BillNo:0,
        PNDX:0,
        Email:"",
        Phone:"",
        DC:"",
      },

      //rem
      Reminder: [],
      displayRem: false,
      btnProColl: false,
      displayPayMethod: false,
      EmployeeRolesStr: [],
      updButton: 1,
      delButton: 1,

      //loader
      loader: "",
     //Timer
      TimerObject: {},
      allPaymentRequests: "",
      filteredPaymentRequests: "",

      filter: {
        externalId: "",
        firstName: "",
        lastName: "",
        phone: "",
        monthYear: "",
        dateFull: "",
      },
      ActivePaymentRequest:{},
      aSinglePaymentReceived: {
        pndx: 0,
        patientId: 0,
        practiceId: 0,
        visitId: 0,
        billNo: 0,
        collectedBy: 0,
        paymentDate: new Date(),
        amount: 0,
        paymentMethod: "",
        holderName: "",
        tdNumber: "",
        cardNumber:"",
        cardCVC: "",
        comment: "",
        zip: "",
      },

      initDate: "",
      startDate: "",
      endDate: "",

      aSinglePayment: "",
      propPatientSource: { visitId: 0, patientId: 0, updButton: 1 }, //-- $$**$$
     
      lastErrorCode: {},
      //Data table
      pageNumber: 1,
      pageSize: 50,
      totalPages: 0,
      Search: "",
      totalRows: 0,
      DataTable: {}, 
      sortColumn: 0,
      sortColumnOption: 0,

      //pay setting
      cardModal: false,
      cashModal: false,
      chequeModal: false,

      //refund Var
      displayRefundMethod:false,
      LimitRefund:null,
      refundMethodType:0,
      refundAmountModal:false,
      refundAmount:"",
      patId: ""
    };
  }, // data()

  methods: {
     //Refund section
    amountRefundCheck(evt,val) {
     //debugger
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;     
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        //Beautiful
        val = val+String.fromCharCode(evt.keyCode)
        if(parseFloat(val) > (this.ActivePaymentRequest.amount - this.ActivePaymentRequest.refundAmount))
        {
          evt.preventDefault();
          return;
        }
        return true;
      }
    },
    sendReceipt(pay){
     //debugger
      this.displayReceipt = true;
      this.patId = pay.patientId;
      this.SendReceiptRequest.PatientId = pay.patientId;
      this.SendReceiptRequest.PracticeId = pay.pacticeId;
      this.SendReceiptRequest.Email = pay.email;
      this.SendReceiptRequest.Phone = pay.phone;
      this.SendReceiptRequest.BillNo = pay.billNo;  
      this.SendReceiptRequest.VisitId = pay.visitId;
      this.SendReceipt.LocalDateTime = new Date;   
      this.SendReceiptRequest.PNDX = pay.pndx;
      this.displayReceipt = true;
    },
    sendReceiptClick() {
     //debugger
      this.displayReceipt = false;
      this.intDummyComm();
      this.dummyComm.patientId = this.patId; 
      this.dummyComm.appModelId = this.AppModelId;
      const myData = this.SendReceiptRequest;
      myData.DC = this.dummyComm;
      const url = this.SERVER + "/VNSPRAAPI/Payments/SendReceiptReminder";  
      this.axiosGetData(url, myData, 2001);
    },
     refundPayment() {
     //debugger
      this.intDummyComm();
      this.dummyComm.patientId = this.patId;
      this.dummyComm.visitId = this.ActivePaymentRequest.visitId;
      this.dummyComm.appModelId = this.AppModelId;
      const myData = { 
        DC: this.dummyComm,
        BillNo:this.ActivePaymentRequest.billNo,
        DateLocalTime: new Date,
        RefundMethod: this.refundMethodType,
        Amount: this.refundAmount        
      }
      const url = this.SERVER + "/VNSPRAAPI/Payments/RefundPayment";
      this.axiosGetData(url, myData, 2002); 
    },
  closeRecepit(){
      this.displayReceipt = false;
    },
 closeRefundAmountModal() {
      this.refundAmountModal = false;
    },
    showSubmitRefundModal(pay){
      this.patId = pay.patientId;
      this.ActivePaymentRequest = pay;
    
      this.refundMethodType = pay.paymentMethod;
      this.displayRefundMethod = false;
      this.refundAmountModal = true;
    },
    closeModalRem() {
      this.displayPayMethod = false;
      this.displayReceipt = false;
      this.displayRem = false;
    },
     //MethodType 1. Credit-Card, 2. Cash, 3. Cheque 
    showSubmitPaymentModal(methodType){
      this.displayPayMethod = false;
      if(methodType==1)
      { this.cardModal = true;}
      else if(methodType==2)
      {this.cashModal = true;}
      else if(methodType==3)
      {this.chequeModal= true;} 
    },

   colorStyle(status){
      if(status==1)//Requested
      {return 'background-color:#03a9f3 ;border-color:#03a9f3';}
      else if(status==2)//Pending
      {return 'background-color:#03a9f3 ;border-color:#03a9f3';}
      else if(status==3)//Disputed
      {return 'background-color:black; border-color:black';}
      else if(status==4)//Paid
      {return 'background-color:#00C292; border-color:#00C292';}
      else if(status==5)//ReFund
      {return 'background-color:#dc3f4e; border-color:#dc3f4e';}
      else if(status==6)//PartiallyRefunded
      {return 'background-color:#DFCE1D; border-color:#DFCE1D';}
      else if(status==7)//PartiallyPaid
      {return 'background-color:#03a9f3; border-color:#03a9f3';}
      else if(status==7)//Deleted
      {return 'background-color:#03a9f3; border-color:#03a9f3';}
      else if(status==9)//Reconciled
      {return 'background-color:#d19e01; border-color:#d19e01';}
    },
    //--$$**$$
    showPatientProfilePopup(pay) { 
      if (pay.visitId > 0 || pay.patientId > 0) {
        this.propPatientSource.visitId = pay.visitId;
        this.propPatientSource.patientId = pay.patientId;
        this.propPatientSource.updButton = this.updButton;
        $("#newptModal").modal("show");
      }
    },

handleRole(){
   this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
   this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
    if(this.EmployeeRolesStr.length > 0){
       this.val = this.EmployeeRolesStr.filter(
      (i)=>i.name == 'Active Requests'
     );
       if(this.val[0].canUpdate == 0){ this.updButton = 0;}
       if(this.val[0].canDelete == 0){ this.delButton = 0;}
}
},

 loader_1() {
    this.loader = this.$loading.show({
            // Optional parameters
              color: '#03a9f3'
            });
 },
     //Timer
   StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    paymentCollectMethodModal(pay) {
      this.displayPayMethod = true;
      this.ActivePaymentRequest = pay;
      this.limitAmount = pay.amount;
      this.aSinglePaymentReceived.amount = this.ActivePaymentRequest.amount;
    },

    deletePayment(pay) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to Delete this Payment. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.value) {
          this.loader_1();
          this.intDummyComm();
          this.dummyComm.extras = pay.status;
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;
          this.dummyComm.filter = "";
          this.dummyComm.appModelId = this.AppModelId;

          const myData = {
            dc: this.dummyComm,
            billNo:pay.billNo,
            pndx:pay.pndx,
            filter: this.$store.state.filterSTGDSP,
            sortColumn: this.sortColumn,
            sortColumnOption: this.sortColumnOption,
          };

          const url = this.SERVER + "/VNSPRAAPI/Trackers/DeletePayment_1";
          this.axiosGetData(url, myData, 6);
        }
      });
    },

 showReconcileModel(pay) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to Reconcile this Payment. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.value) {
          this.loader_1();
          this.intDummyComm();
          this.dummyComm.extras = pay.status;
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;
          this.dummyComm.extras2 = pay.billNo;
          this.dummyComm.filter = "";
          this.dummyComm.appModelId = this.AppModelId;

          const myData = {
            dc: this.dummyComm,
            pndx: pay.pndx,
            filter: this.$store.state.filterSTGDSP,
            sortColumn: this.sortColumn,
            sortColumnOption: this.sortColumnOption,
          };

          const url = this.SERVER + "/VNSPRAAPI/Trackers/ReconcilePayment";
          this.axiosGetData(url, myData, 900);
        }
      });
    },

    statusChanged(pay) {
      console.log(pay.status, pay.oldStatus);
      if (pay.status == pay.oldStatus) return;
      this.aSinglePayment = JSON.parse(JSON.stringify(pay));
      // if changed to paid then show payment modals
      if (pay.status == 4) {
        Swal.fire({
          title: "Are you sure?",
          text: "You want to change Payment Status. This action cannot be undone. Are you sure you want to continue?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#00c292",
          confirmButtonText: "Continue",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.value) {
            this.showCollectPaymentModel();
          }
        }); // swal
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: "You want to change Payment Status. This action cannot be undone. Are you sure you want to continue?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#00c292",
          confirmButtonText: "Continue",
        }).then((result) => {
          if (result.value) {
            this.intDummyComm();
            this.dummyComm.extras = pay.status;
            this.dummyComm.visitId = pay.visitId;
            this.dummyComm.patientId = pay.patientId;
            this.dummyComm.appModelId = this.AppModelId;

            const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdatePaymentStatus";
            const myData = this.dummyComm;

            this.axiosGetData(url, myData, 100);
          }
        }); // swal
      }

      //alert(pay.status);
      // if changed to paid then show payment modals
      if (pay.status == 4) {
        this.showCollectPaymentModel();
      }
    },

    paymentReceivedClick(what) {
      const valueAmount = this.aSinglePaymentReceived.amount;
      if (what == "cheque") {
        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.showErrorToast("Cheque Number is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.holderName == 0) {
          this.showErrorToast("Holder name is require");
          return;
        }
        if (this.aSinglePaymentReceived.comment == 0) {
          this.showErrorToast("comment is require");
          return;
        }
        if (valueAmount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
        if(this.aSinglePaymentReceived.amount>this.limitAmount)
        {
          this.showErrorToast("Amount can not be greater then requested $" +this.limitAmount)
          return;
        }
      }
      if (what == "cash") {
        if (this.aSinglePaymentReceived.amount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
      } else if (what == "credit-card") {
        if (this.aSinglePaymentReceived.cardCVC == "") {
          this.showErrorToast("Card CVC is require");
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.showErrorToast("Card CVC must be of 3 length");
          return;
        }
        if (this.aSinglePaymentReceived.comment == "") {
          this.showErrorToast("Comment is require");
          return;
        }
        if (this.aSinglePaymentReceived.zip == "") {
          this.showErrorToast("Zip is require");
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.showErrorToast("Zip must be of 3 length");
          return;
        }
        if (this.aSinglePaymentReceived.cardNumber== "") {
          this.showErrorToast("Card Number is require");
          return;
        }
        if (this.aSinglePaymentReceived.holderName == "") {
          this.ShowWarning("Holder Name is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
      }
      if(what == "credit-card")
      {
        this.aSinglePaymentReceived.tdNumber = this.aSinglePaymentReceived.cardNumber; 
      }
      this.aSinglePaymentReceived.paymentMethod = what;
      this.aSinglePaymentReceived.visitId = this.ActivePaymentRequest.visitId;
      this.aSinglePaymentReceived.patientId = this.ActivePaymentRequest.patientId;
      this.aSinglePaymentReceived.pndx = this.ActivePaymentRequest.pndx;

      this.intDummyComm();
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.dummyComm.appModelId = this.AppModelId;
      const myData = {
         dc: this.dummyComm, 
         pr: this.aSinglePaymentReceived,
         filter: this.$store.state.filterSTGDSP,
         sortColumn: this.sortColumn,
         sortColumnOption: this.sortColumnOption
       };
      
      this.btnProColl = true;
         const url = this.SERVER + "/VNSPRAAPI/Trackers/SavPayRec_1";
         this.axiosGetData(url, myData, 1001);
    },

    showCollectPaymentModel() {
      this.aSinglePaymentReceived.amount = this.aSinglePayment.amount;
      $("#paymentMethod").modal("show");
    },

     sendReminderClick() {
      //debugger
      if (this.Reminder.email == "") {
        this.showErrorToast("Email is require");
        return;
      }
      if (this.Reminder.phone == "") {
        this.showErrorToast("Phone is require");
        return;
      }

      this.intDummyComm();
      this.dummyComm.visitId = this.Reminder.visitId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.dummyComm.patientId = this.Reminder.patientId;
      this.dummyComm.appModelId = this.AppModelId;
      this.dummyComm.extras2 = localStorage.getItem("PracticeName");

      const url = this.SERVER + "/VNSPRAAPI/Trackers/SendPaymntReminder";

      const Reminder1 = {
        PNDX: this.Reminder.pndx,
        BillNo: this.Reminder.billNo,
        VisitId: this.Reminder.visitId,
        PatientId: this.Reminder.patientId,
        Amount: this.Reminder.amount,
        Email: this.Reminder.email,
        Phone: this.Reminder.phone,
      };

      const myData = { dc: this.dummyComm, pr: Reminder1 };
      this.axiosGetData(url, myData, 2);
    },

   showReminderModel(pay) {
    //debugger
      this.displayRem = true;
      this.Reminder = JSON.parse(JSON.stringify(pay));
    },

    dropdownButtonClick(pay) {
      this.aSinglePayment = JSON.parse(JSON.stringify(pay));
    },

    datePicker() {
      let ss = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function (start, end) {
          ss.startDate = new Date(start);
          ss.endDate = new Date(end);
          ss.initDate =
            ss.dateToMDY(ss.startDate) + " - " + ss.dateToMDY(ss.endDate);
        }
      );
    },

    performFilter() {
      if (this.allPaymentRequests.length < 1) return;
      let obj = JSON.parse(JSON.stringify(this.allPaymentRequests));
      console.log("OBJ: ", obj);

      try{
        if (this.filter.externalId.length > 0) {
        this.filteredPaymentRequests = this.allPaymentRequests.filter((f) =>
          (f.externalId + " ").includes(this.filter.externalId)
        );
      } else {
        this.filteredPaymentRequests = this.allPaymentRequests.filter(
          (f) =>
            f.firstName
              .toLowerCase()
              .startsWith(this.filter.firstName.toLowerCase().trim()) &&
            f.lastName
              .toLowerCase()
              .startsWith(this.filter.lastName.toLowerCase().trim()) &&
            f.phone.startsWith(this.filter.phone.toLowerCase().trim())
        );
      } 
      }catch { /**/}
    },
     getPaymentResTable(visitId,patientId) {
     //debugger
     this.intDummyComm();
       console.log("paymentrestable");
      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize; 
      this.dummyComm.patientId = patientId;
      this.dummyComm.visitId = visitId;
      this.dummyComm.appModelId = this.AppModelId;
      this.dummyComm.filter = "";

      const myData = {
        dc: this.dummyComm,
        filter: this.$store.state.filterSTGDSP,
        sortColumn: this.sortColumn,
        sortColumnOption: this.sortColumnOption,
      };
      console.log(myData);
      myData.filter.startDate = "1805-02-01";
      myData.filter.endDate = "2100-10-31";
      
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsList";
      this.axiosGetData(url, myData, 1);
      this.StartLogoutTime();
    },
    loadInit() {
      this.intDummyComm();
      console.log("load");
      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = "";
      this.dummyComm.appModelId = this.AppModelId;
      debugger;
      console.log(this.removeids);
      if(this.removeids===true)
      {
        this.dummyComm.patientId = 0;
        this.dummyComm.visitId = 0;
      }

      const myData = {
        dc: this.dummyComm,
        filter: this.$store.state.filterSTGDSP,
        sortColumn: this.sortColumn,
        sortColumnOption: this.sortColumnOption,
      };
      
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsList";
      this.axiosGetData(url, myData, 1);
      this.StartLogoutTime();
    },
    //code for Data-Tables_
    pageChange(obj) {
      if (obj == "Next") {
        if (this.pageNumber < this.totalPages) {
          this.pageNumber += 1;
        }
      } else if (obj == "Previous" && this.pageNumber != 1) {
        this.pageNumber -= 1;
      } else {
        this.pageNumber = obj;
      }

        if((this.showPagesMax/2) < (this.pageNumber))
        {
          this.showPagesMin = this.pageNumber-4;
          this.showPagesMax = this.pageNumber+4;
        }
        else if((this.showPagesMin/2)<(this.pageNumber))
        {
          this.showPagesMin = this.pageNumber-4;
          this.showPagesMax = this.pageNumber+4 ;
          if(this.showPagesMax<5)
          {
            this.showPagesMax = 5;
          }
        }
        else{
          this.showPagesMin = 1;
          this.showPagesMax = 5 ;
        }
      this.loadInit();
    },

    orderBy(column) {
      if (this.sortColumn == column) {
        switch (this.sortColumnOption) {
          case 0:
            this.sortColumnOption = 1;
            break;
          case 1:
            this.sortColumnOption = 2;
            break;
          case 2:
            this.sortColumn = 0;
            this.sortColumnOption = 0;
            break;
        }
      } else {
        this.sortColumn = column;
        this.sortColumnOption = 1;
      }
      this.pageNumber = 1;
      this.loadInit();
    },

    orderByRemeber(column) {
     //debugger
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.firstName < b.firstName ? 1 : b.firstName < a.firstName ? -1 : 0
          );
        } else {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.lastName > b.lastName ? 1 : b.lastName > a.lastName ? -1 : 0
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.visitType < b.visitType ? 1 : b.visitType < a.visitType ? -1 : 0
          );
        } else {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.visitType > b.visitType ? 1 : b.visitType > a.visitType ? -1 : 0
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.dos < b.dos
              ? 1
              : b.dos < a.dos
              ? -1
              : 0
          );
        } else {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.dos > b.dos
              ? 1
              : b.dos > a.dos
              ? -1
              : 0
          );
        }
      }
           if (column == 3) {
        if (this.asc_desc == "asc") {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.CheckedoutLocalDate < b.CheckedoutLocalDate
              ? 1
              : b.CheckedoutLocalDate < a.CheckedoutLocalDate
              ? -1
              : 0
          );
        } else {
          this.allFilterPatientsCheck = this.allFilterPatientsCheck.sort((a, b) =>
            a.CheckedoutLocalDate > b.CheckedoutLocalDate
              ? 1
              : b.CheckedoutLocalDate > a.CheckedoutLocalDate
              ? -1
              : 0
          );
        }
      }
    },
    //-------------------- Common Methods
    async axiosGetData(myUrl, myData, what) {
      var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          loader.hide();
          if (what === 1) {
            if (res.status == 200) {
              this.allPaymentRequests = res.data.list;
              this.filteredPaymentRequests = res.data.list;
              this.totalRows=res.data.dc.totalRow;
              this.totalPages = res.data.dc.totalPages;
              if(what===12) {
                $("#paymentMethod").modal("hide");
                $("#cheque").modal("hide");
                $("#cash").modal("hide");
                $("#debit").modal("hide");
              }
            }
          } else if (what === 12) {
              this.successToastUpd("Information updated");
               this.allPaymentRequests = res.data;
               this.filteredPaymentRequests = res.data;
               $("#paymentMethod").modal("hide");
              $("#cheque").modal("hide");
              $("#cash").modal("hide");
              $("#debit").modal("hide");
              location.reload();
          }  
          else if (what === 2) {
            //if(res.data.dc.auditFlag>0) {
            this.ShowSuccess("Send Reminder Successful!")
            this.displayRem = false;
            //}
          } else if (what == 6) {
            this.loader.hide();
            this.ShowSuccess("Delete Payment Successful!")  
            this.allPaymentRequests = res.data;
            this.loadInit();
            //this.$router.go(0);
          } else if (what == 900) {
            this.loader.hide();
            this.ShowSuccess("Reconcile Payment Successful!")  
            this.allPaymentRequests = res.data.list;
            this.loadInit();
            //this.$router.go(0);
          } else if (what == 100) {
            this.successToastUpd();
            this.allPaymentRequests = res.data;
            this.filteredPaymentRequests = res.data;
            //this.$router.go(0);
          } else if (what == 1001) {
           //debugger
             if (res == "err" || res.data.dc.auditFlag < 0) {
               this.ShowError("Unable to save. " + res.data.dc.auditFlagVal);
               this.btnProColl = false;
               loader.hide();
           } else {
          for(let k=0;k<res.data.list.length;k++){
            //dos
            res.data.list[k].dos = res.data.list[k].dos.split("T");
            res.data.list[k].dos = res.data.list[k].dos[0];
            //dare req
            res.data.list[k].billDate = res.data.list[k].billDate.split("T");
            res.data.list[k].billDate = res.data.list[k].billDate[0];
          }  
          loader.hide(); 
          this.filteredPaymentRequests = res.data.list;
          this.totalRows = res.data.dc.totalRow;
          this.totalPages = res.data.dc.totalPages;
          this.ShowSuccess("Payment processed successfully.");
          this.btnProColl = false;
          this.aSinglePaymentReceived.cardNumber = "";
          this.aSinglePaymentReceived.tdNumber = "";
          this.aSinglePaymentReceived.holderName = "";
          this.aSinglePaymentReceived.cardCVC = "";
          this.aSinglePaymentReceived.ExpirationDate = "";
          this.aSinglePaymentReceived.comment = "";
          this.aSinglePaymentReceived.zip = "";
          this.aSinglePaymentReceived.amount="";
          this.cardModal = false;
          this.chequeModal = false;
          this.cashModal = false;
           }
          } else if(what == 2001){
           //debugger
            loader.hide();
           if (res.status == false) {
          this.showErrorToast(res.message);
        } else {
          this.ShowSuccess("Send Receipt Successful!")
          this.refundAmountModal=false;
          this.loadInit();
          }
          } else if(what == 2002){
           //debugger
            loader.hide();
           if (res == "err") {
          this.showErrorToast("Unable to load data.");
        } else {
          if(res.data.dc.auditFlag<0)
          {
            this.showErrorToast(res.data.dc.auditFlagVal);
          }
          else{
          this.ShowSuccess("Amount Refunded Successful!")
          this.refundAmountModal=false;
          }
          // for(let k=0;k<res.data.list.length;k++){
          //   //dos
          //   res.data.list[k].dos = res.data.list[k].dos.split("T");
          //   res.data.list[k].dos = res.data.list[k].dos[0];
          //   //dare req
          //   res.data.list[k].billDate = res.data.list[k].billDate.split("T");
          //   res.data.list[k].billDate = res.data.list[k].billDate[0];
          // }  
          this.refundAmount = "";
          //this.filteredPaymentRequests = res.data.list;
          //this.totalRows = res.data.dc.totalRow;
          //this.totalPages = res.data.dc.totalPages;
          this.loadInit();
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          try{
            this.FetchTableData();
          }
          catch(e)
          {console.log(e.message)}
          loader.hide();
            this.ResetLogoutTime();
        });
    }, // axiosGetData
  }, // methods

  watch: {
    allPaymentRequests: function () {
       try {
      for (let i = 0; i < this.allPaymentRequests.length; i++) {
        let dd = new Date(this.allPaymentRequests[i].dob);
        this.allPaymentRequests[i].dob = dd.toLocaleDateString();
        dd = new Date(this.allPaymentRequests[i].dos);
        this.allPaymentRequests[i].dos = dd.toLocaleDateString();
        dd = new Date(this.allPaymentRequests[i].billDate);
        this.allPaymentRequests[i].billDate = dd.toLocaleDateString();
        this.allPaymentRequests[i].billDateDate = dd;

        this.allPaymentRequests[i].monthYear = this.dateToYM(dd);
        this.allPaymentRequests[i].dateFull = this.dateToYMD(dd);

        this.allPaymentRequests[i].oldStatus =
          this.allPaymentRequests[i].status;
         }
       }
      catch {
        /**/
      } finally {
        /**/
      this.filteredPaymentRequests = this.allPaymentRequests;
      this.performFilter();
      // this.$nextTick(() => {
      //   $("#table001").DataTable().destroy();
      //   $("#table001").DataTable({
      //       buttons: [
      //               'copy', 'csv', 'excel', 'pdf', 'print'
      //       ]
      //     });
      //     $('.buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel').addClass('btn btn-primary mr-1');
      //   $(".table001").DataTable().draw();
      // });
      }
    },
  
  // filteredPaymentRequests: function () {
  //     this.$nextTick(() => {
  //       $("#table001").DataTable().destroy();
  //       $("#table001").DataTable({
  //         buttons: ["copy", "csv", "excel", "pdf", "print"],
  //       });
  //       $(
  //         ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
  //       ).addClass("btn btn-primary mr-1");
  //       $(".table001").DataTable().draw();
  //     }); // this.$nextTick
  //   }, 

    initDate: function (val) {
      if (val == "") return;
      this.intDummyComm();
      this.dummyComm.myTime = "range";
      this.dummyComm.extras1 = this.dateToYMD(this.startDate);
      this.dummyComm.extras2 = this.dateToYMD(this.endDate);
      this.dummyComm.appModelId = this.AppModelId;

      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsList";

      this.axiosGetData(url, this.dummyComm, 1);

      this.performFilter();
    },

    "filter.monthYear": function (val) {
      this.filter.monthYear = this.dateToYMD(new Date(val));

      this.intDummyComm();
      this.dummyComm.myTime = "my";
      this.dummyComm.extras1 = this.filter.monthYear;
      this.dummyComm.appModelId = this.AppModelId;
      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsList";

      this.axiosGetData(url, this.dummyComm, 1);

      this.performFilter();
    },
  },

  mounted() {        
  }, // mounted
};
</script>

<style scoped>
.float-class:hover {
  border-bottom: 1px solid rgb(235, 235, 235);
  width: 98%;
}
.float-class1:hover {
  border-bottom: 1px solid rgb(235, 235, 235);
  width: 200px;
}
#font1{
    font-weight: 600;
    font-size: 15px;
    margin-top:-4.5px;
}


.float-class:hover {
  border-bottom: 1px solid rgb(235, 235, 235);
  width: 98%;
}
.float-class1:hover {
  border-bottom: 1px solid rgb(235, 235, 235);
  width: 200px;
}
#font1{
    font-weight: 600;
    font-size: 15px;
    margin-top:-4.5px;
}
</style>
<style scoped>
  .float-textarea,
  .float-class:hover {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    border-bottom: 1px solid rgb(235, 235, 235);
    /* box-shadow: none; */
    width: 98%;
  }

  .float-textarea:focus {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    border-bottom: 2px solid rgb(240, 141, 11);
    /* box-shadow: none; */
    width: 98%;
  }

  .float-class,
  .float-class:hover {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    /* border-bottom: 2px solid rgb(240, 141, 11); */
    border-bottom: 1px solid rgb(235, 235, 235);
    box-shadow: none;
  }

  .float-class:focus {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    background: transparent;
    border-bottom: 2px solid rgb(240, 141, 11);
    box-shadow: none;
  }

  #font1 {
    font-weight: bold;
    font-size: 15px;
    margin-left: -7px;
  }

  .label_select {
    margin-top: -23px;
    margin-left: 0px;
  }

  .activeColor {
    background-color: #fb9678;
    color: white;
  }

  .colorActive {
    color: #f95c2e
  }

  .disabledColor {
    color: gray;
    background: lightgrey;
  }

  .asc-desc-btn {
    background-color: transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    color: honeydew;
    float: right;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked+.slider {
    background-color: #00c292;
  }

  input:focus+.slider {
    box-shadow: 0 0 1px #00c292;
  }

  input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  .slider.round {
    height: 34px;
    width: 56px;
    border-radius: 24px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .label-color {
    color: black;
  }
</style>